import * as Yup from 'yup'


export const merchantScema = Yup.object().shape({
    name: Yup.string().required('Merchant name is required').min(1, 'Merchant name must be at least 1 characters').max(255, 'Merchant name must be at most 255 characters')
})